import React from "react";
import ProjectionLayoutBase from "./LayoutBase";

interface ProjectionLayoutProps {
    children: React.ReactNode;
}

export default function ProjectionLayout({ children }: ProjectionLayoutProps) {
    return <ProjectionLayoutBase children={children} footer floatButtons />;
}
